<template>
  <div class="stepper-wrapper">
    <div v-for="(label, index) in labels" :key="label" class="stepper-item">
      <div class="stepper-icon-wrapper">
        <span class="stepper-icon active-stepper-icon" v-if="step > index">
          <stepper-check />
        </span>
        <span class="stepper-icon" v-else>
          <stepper-uncheck />
        </span>
        <div
          v-if="index < labels.length - 1"
          :class="['stepper-line', { active: step > index + 1 }]"
        ></div>
      </div>
      <div class="stepper-content">
        <component :is="icons[index]" class="step-icon" />
        <p :class="{ completed: step > index }" class="mb-0">{{ label }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import ParcelIcon from "./Iconsvg/ParcelIcon.vue";
import VanIcon from "./Iconsvg/VanIcon.vue";
import Home from "./Iconsvg/Home.vue";
import StepperCheck from "./Iconsvg/StepperCheck.vue";
import StepperUncheck from "./Iconsvg/StepperUncheck.vue";

export default {
  components: { StepperCheck, StepperUncheck, ParcelIcon, VanIcon, Home },
  name: "DispatchStepperVertical",
  props: {
    step: Number,
    labels: Array,
  },
  computed: {
    icons() {
      return [ParcelIcon, VanIcon, Home];
    },
  },
};
</script>

<style scoped>
.stepper-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* padding: 1rem; */
  min-height: 15rem;
  justify-content: space-between;
}

.stepper-item {
  display: flex;
  align-items: center;
  position: relative;
  /* margin-bottom: 2rem; */
}

.stepper-icon-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-right: 1rem;
}

.stepper-icon {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d3d3d3;
  border-radius: 50%;
}

.active-stepper-icon {
  background-color: #213e7a;
}

.stepper-line {
  width: 8px;
  height: calc(100% - -4rem);
  background-color: #d3d3d3;
  position: absolute;
  top: 23px;
}

.stepper-line.active {
  background-color: #213e7a;
}

.stepper-content {
  display: flex;
  align-items: center;
}

.step-icon {
  margin-right: 0.5rem;
}

.completed {
  color: #213e7a;
  font-weight: bold;
}
</style>
